import React from 'react'
import { Flex, IconCheck, IconClose } from '@dostavkee/web-ui'

import {
    DomainRecruiterNewDriverStatusEnum as RecruitmentConfirmStatus,
    type V1RecruitmentModel,
    V1RequestStateStringEnum as RequestStatus,
    type V1UserRequestModel,
} from '@/shared/api'
import { IconWait } from '@/shared/ui/icon-wait'
import { RoundIcon } from '@/shared/ui/round-icon'

import { RECRUITMENT_CONFIRM_STATUS_TO_TEXT } from '../../model/constants'
import { getRequestStatusText } from '../../model/get-request-status-text'
import styles from './recruitment-connection-stages.module.scss'

interface RecruitmentConnectionStagesProps {
    recruitment: V1RecruitmentModel
}

export const RecruitmentConnectionStages: React.FC<RecruitmentConnectionStagesProps> = ({
    recruitment,
}) => {
    const { user_request, status } = recruitment

    return (
        <Flex direction='column' spacing='2xs'>
            <Flex direction='row' spacing='xs' wrap='nowrap'>
                <RoundIcon>
                    <UserRequestStatusIcon user_request={user_request} />
                </RoundIcon>
                <div>
                    <span className={styles['recruitment-connection-stages__label']}>Анкета:</span>{' '}
                    <span>
                        {user_request
                            ? getRequestStatusText(user_request, recruitment.status)
                            : 'Уже существует'}
                    </span>
                </div>
            </Flex>
            <Flex direction='row' spacing='xs' wrap='nowrap'>
                <RoundIcon>
                    <RecruitmentConfirmStatusIcon status={recruitment.status} />
                </RoundIcon>
                <div>
                    <span className={styles['recruitment-connection-stages__label']}>
                        Подтверждение:
                    </span>{' '}
                    <span>{RECRUITMENT_CONFIRM_STATUS_TO_TEXT[status]}</span>
                </div>
            </Flex>
        </Flex>
    )
}

const UserRequestStatusIcon: React.FC<{ user_request?: V1UserRequestModel }> = ({
    user_request,
}) => {
    if (!user_request) {
        return <IconCheck color='var(--extensions-text-and-icon-success)' size={10} />
    }

    if (user_request.deleted_at) {
        return <IconClose color='var(--extensions-text-and-icon-error)' size={10} />
    }

    switch (user_request.state) {
        case RequestStatus.requestStateAcceptString: {
            return <IconCheck color='var(--extensions-text-and-icon-success)' size={10} />
        }
        case RequestStatus.requestStateCheckinString:
        case RequestStatus.requestStateIdleString: {
            return <IconWait color='var(--text-and-icon-secondary)' size={10} />
        }
        case RequestStatus.requestStateDeclineString:
        case RequestStatus.requestStateUnknownString: {
            return <IconClose color='var(--extensions-text-and-icon-error)' size={10} />
        }
        default: {
            return null
        }
    }
}

const RecruitmentConfirmStatusIcon: React.FC<{ status: RecruitmentConfirmStatus }> = ({
    status,
}) => {
    switch (status) {
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusNew:
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusNotified: {
            return <IconWait color='var(--text-and-icon-secondary)' size={10} />
        }
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusConfirmed: {
            return <IconCheck color='var(--extensions-text-and-icon-success)' size={10} />
        }
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusDeclined:
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusCanceled:
        case RecruitmentConfirmStatus.RecruiterNewDriverStatusError: {
            return <IconClose color='var(--extensions-text-and-icon-error)' size={10} />
        }
        default: {
            return null
        }
    }
}
